/**
 * Section / CardLink — linguaggio visivo condiviso "card morbida".
 *
 * Card arrotondata, bordo tenue, header con icona + titolo (glow) + sottotitolo.
 * Usato per dare coerenza alle schermate (Impostazioni, Info & sicurezza, …)
 * mantenendo l'identità terminale (verde fosforo su nero), solo più leggibile.
 *
 *  - <Section> : card COLLASSABILE (header cliccabile, corpo a fisarmonica).
 *  - <CardLink>: card di NAVIGAZIONE (tap → onClick), con freccia →.
 */

import { useState } from 'react';

export function Section({ icon, title, subtitle, defaultOpen = false, tone, children }) {
  const [open, setOpen] = useState(defaultOpen);
  const danger = tone === 'danger';
  const wrap = danger ? 'border-redphos/40 bg-redphos/[0.03]' : 'border-ink-dim/50 bg-ink/[0.015]';
  const titleC = danger ? 'text-redphos' : 'text-ink text-glow';
  const divider = danger ? 'border-redphos/20' : 'border-ink-dim/25';
  return (
    <div className={`border rounded-xl mb-3 overflow-hidden ${wrap}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-ink/[0.06] transition-colors"
      >
        {icon != null && <span className="text-[20px] leading-none w-7 text-center shrink-0">{icon}</span>}
        <span className="flex-1 min-w-0">
          <span className={`block text-[16px] leading-tight ${titleC}`}>{title}</span>
          {subtitle && <span className="block text-[12px] text-ink-dim mt-0.5 leading-tight">{subtitle}</span>}
        </span>
        <span className={`text-ink-dim text-[15px] shrink-0 transition-transform duration-200 ${open ? 'rotate-90' : ''}`}>▸</span>
      </button>
      {open && (
        <div className={`px-4 pb-4 pt-2 space-y-2 border-t ${divider}`}>
          {children}
        </div>
      )}
    </div>
  );
}

export function CardLink({ icon, title, subtitle, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-3 text-left border border-ink-dim/50 rounded-xl mb-3 bg-ink/[0.015] hover:bg-ink/[0.06] transition-colors"
    >
      {icon != null && <span className="text-[20px] leading-none w-7 text-center shrink-0">{icon}</span>}
      <span className="flex-1 min-w-0">
        <span className="block text-[16px] text-ink text-glow leading-tight">{title}</span>
        {subtitle && <span className="block text-[12px] text-ink-dim mt-0.5 leading-tight">{subtitle}</span>}
      </span>
      <span className="text-ink-dim text-[16px] shrink-0">→</span>
    </button>
  );
}
